import { FormattedMessage } from "react-intl";
import CustomSelect from "../CustomSelect";
import { SeasonStatuses } from "~enums/seasonStatuses";

const options = Object.values(SeasonStatuses).map((value) => ({ value, label: <FormattedMessage id={`seasonStatus.${value}`} /> }));

type Props = {
  className?: string;
  disabled?: boolean;
  onChange?: (value: string) => void;
  defaultValue?: string;
  value?: string | null;
}

const SelectSeasonStatus = ({ className, disabled, onChange, defaultValue, value }: Props) => (
  <CustomSelect
    style={{ minWidth: "130px" }}
    value={value}
    defaultValue={defaultValue}
    onChange={(value) => onChange?.(value as string)}
    options={options}
    placeholder={<FormattedMessage id="status" />}
    allowClear
    className={className}
    disabled={disabled}
  />
);

export default SelectSeasonStatus;
